import axios from 'axios';
import config from '../config/config';

/**
 * Check if a user can add an event on a specific date
 * @param {string} date - The date to check (YYYY-MM-DD format)
 * @param {string} token - Authentication token
 * @param {string} userId - User ID (optional, for non-admin users)
 * @returns {Promise<{canAdd: boolean, currentCount: number, message?: string}>}
 */
export const checkEventLimit = async (date, token, userId = null) => {
  try {
    const apiUrl = `${config.API_URL}/api`;
    
    // Get ALL events for the specific date (not filtered by user)
    const response = await axios.get(`${apiUrl}/events`, {
      headers: { Authorization: `Bearer ${token}` }
    });

    const events = response.data || [];
    
    // Filter events for the specific date (check ALL events, not just user's events)
    const eventsOnDate = events.filter(event => {
      const eventDate = new Date(event.date).toISOString().split('T')[0];
      return eventDate === date;
    });

    const currentCount = eventsOnDate.length;
    const canAdd = currentCount < 3;

    return {
      canAdd,
      currentCount,
      message: canAdd 
        ? null 
        : `Cette journée est complète. Il y a déjà ${currentCount} événements ce jour. Seul l'administrateur peut ajouter plus d'événements.`
    };
  } catch (error) {
    console.error('Error checking event limit:', error);
    return {
      canAdd: true, // Allow submission if check fails
      currentCount: 0,
      message: null
    };
  }
};

/**
 * Get event count for a specific date (ALL events, not just user's events)
 * @param {string} date - The date to check (YYYY-MM-DD format)
 * @param {string} token - Authentication token
 * @returns {Promise<number>}
 */
export const getEventCountForDate = async (date, token) => {
  try {
    const apiUrl = `${config.API_URL}/api`;
    
    // Get ALL events (not filtered by user)
    const response = await axios.get(`${apiUrl}/events`, {
      headers: { Authorization: `Bearer ${token}` }
    });

    const events = response.data || [];
    
    // Filter events for the specific date (check ALL events, not just user's events)
    const eventsOnDate = events.filter(event => {
      const eventDate = new Date(event.date).toISOString().split('T')[0];
      return eventDate === date;
    });

    return eventsOnDate.length;
  } catch (error) {
    console.error('Error getting event count:', error);
    return 0;
  }
};
